/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SyncDefs from './defs.defs.js'

const $nsid = 'com.atproto.sync.listHosts'

export { $nsid }

/** Enumerates upstream hosts (eg, PDS or relay instances) that this service consumes from. Implemented by relays. */
const main = l.query(
  $nsid,
  l.params({
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 1000 }), 200),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    cursor: l.optional(l.string()),
    hosts: l.array(l.ref<Host>((() => host) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Host = {
  $type?: 'com.atproto.sync.listHosts#host'

  /**
   * hostname of server; not a URL (no scheme)
   */
  hostname: string

  /**
   * Recent repo stream event sequence number. May be delayed from actual stream processing (eg, persisted cursor not in-memory cursor).
   */
  seq?: number
  accountCount?: number
  status?: SyncDefs.HostStatus
}

export type { Host }

const host = l.typedObject<Host>(
  $nsid,
  'host',
  l.object({
    hostname: l.string(),
    seq: l.optional(l.integer()),
    accountCount: l.optional(l.integer()),
    status: l.optional(
      l.ref<SyncDefs.HostStatus>((() => SyncDefs.hostStatus) as any),
    ),
  }),
)

export { host }
